import axios from "axios";
import { APIAdapter } from "../../../helpers/api_helper";
const api = new APIAdapter();

export const sendKycDocument = async (formData) => {
  try {
    const response = await axios.post(
      "https://api-kyc.systalink.fr/api/v1/informations",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": "Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJUZXN0IFdlYmhvb2sgQXBwIGZvciBQYXhpdHkiLCJzZXJ2aWNlIjoiRVhUUkFDVF9EQVRBIiwiaWF0IjoxNzQxNjg2NTA1fQ.YaGb28Ppfjpx9kkDHPR1PgVj4hrgMl1RVee580nbLlw"
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getAllCountry = async (data) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_API_TRANSACTION + `/country/`,
      data
      
    );
 
   
    return response;
    
  } catch (error) {
    console.error("Erreur API getAllCountry", error);
    throw error;
  }
};

export const compareFaces = async (formData) => {
  console.log("Body request", formData);
  const res = await axios.post("https://api-kyc.systalink.fr/api/v1/check_identity", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Authorization": "Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJUZXN0IFdlYmhvb2sgQXBwIGZvciBpZGVudGlmeSIsInNlcnZpY2UiOiJUSFJFRV9JTl9PTkUiLCJpYXQiOjE3NDU5MjAyNTd9.FkYeN-gZYTi3IMl1dgfgRSKdEhl7aiACu7IpY9MPtPI"
    },

  });
  return res;
};

export const finalizeVerification = async (values) => {
  const payload = {
    documentType: values.documentType,
    data: {
      'filenameRecto': values.filenameRecto,
      'filenameVerso': values.filenameVerso
    },
  };
  const response = await axios.post(process.env.REACT_APP_API_URL + '/merchants/kyc-status/' + values.merchantId, payload,
    {
      headers: {
        "Authorization": `Bearer ${values.token}`
      }
    });
  return response;
}

export const uploadDocument = async (values) => {
  const formData = new FormData();
  formData.append("file", values.file);

  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/files/upload/${values.category}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${values.token}`,
      }
    }
  );
  return response;
}
